(function ($) {
    "use strict";

    var $body = $('body');

    // Background image/color from data attributes (used across sections)
    $('[data-bg-image]').each(function () {
        $(this).css('background-image', 'url(' + $(this).data('bg-image') + ')');
    });
    $('[data-bg-color]').each(function () {
        $(this).css('background-color', $(this).data('bg-color'));
    });

    // Header sticky — pins the header once you've scrolled past it.
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 350) {
            $('.sticky-header').addClass('is-sticky');
        } else {
            $('.sticky-header').removeClass('is-sticky');
        }
    });

    // Off-canvas mobile menu (site-main-mobile-menu)
    $('.header-mobile-menu-toggle, .mobile-menu-close').on('click', '.toggle', function () {
        $body.toggleClass('mobile-menu-open');
    });
    $('.site-mobile-menu').on('click', '.menu-toggle', function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.siblings('.sub-menu:visible').length) {
            $this.siblings('.sub-menu').slideUp().parent().removeClass('open');
        } else {
            $this.siblings('.sub-menu').slideDown().parent().addClass('open')
                .siblings().find('.sub-menu').slideUp().parent().removeClass('open');
        }
    });
    $body.on('click', function (e) {
        if (!$(e.target).closest('.site-main-mobile-menu-inner').length && !$(e.target).closest('.header-mobile-menu-toggle').length) {
            $body.removeClass('mobile-menu-open');
        }
    });

    AOS.init({
        offset: 80,
        duration: 1000,
        once: true,
        easing: 'ease',
    });

    // Hero slider (SliderBlock)
    document.querySelectorAll('.hero-slider').forEach(function (el) {
        var slideCount = el.querySelectorAll('.swiper-slide').length;
        new Swiper(el, {
            loop: slideCount > 1,
            speed: 750,
            effect: 'fade',
            fadeEffect: {crossFade: true},
            pagination: slideCount > 1 ? {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            } : false,
        });
    });

    // Animation shapes (mouse-move parallax, e.g. AboutBlock's shape-2)
    document.querySelectorAll('.scene').forEach(function (el) {
        new Parallax(el);
    });

    // Gallery lightbox (GalleryBlock)
    var $galleryGrid = $('.gallery-grid');
    if ($galleryGrid.length) {
        $galleryGrid.magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {enabled: true},
        });
    }

})(jQuery);
